const baseUrl = '/admin';
export const adminApiRoutes = {
  baseUrl: "".concat(baseUrl),
  companies: "".concat(baseUrl, "/company"),
  company: id => "".concat(baseUrl, "/company/").concat(id),
  createAccount: "".concat(baseUrl, "/account"),
  loginImpersonate: _ref => {
    let companyId = _ref.companyId;
    return "".concat(baseUrl, "/account/impersonate/").concat(companyId);
  },
  adminAccounts: "".concat(baseUrl, "/account/admins"),
  updateAdmin: accountId => "".concat(baseUrl, "/account/admins/").concat(accountId),
  deleteAdmin: _ref2 => {
    let accountId = _ref2.accountId;
    return "".concat(baseUrl, "/account/admins/").concat(accountId);
  },
  utilityCredentials: '/utilityPortalCredentials',
  disableUtilityCredential: credentialId => "/utilityPortalCredentials/".concat(credentialId, "/disable"),
  utilityCredentialEntitlement: '/utilityPortalCredentials/entitlement',
  billScrapingHealth: '/billscraping/health',
  billScrapingProviders: '/billscraping/providers',
  billQueue: '/billqueue',
  billQueueCycles: '/billqueue/cycles',
  billQueueClaim: allocationTableId => "/billqueue/".concat(allocationTableId, "/claim"),
  billQueueRelease: allocationTableId => "/billqueue/".concat(allocationTableId, "/release"),
  billQueueState: allocationTableId => "/billqueue/".concat(allocationTableId, "/state"),
  billQueueBill: allocationTableId => "/billqueue/".concat(allocationTableId, "/bill"),
  billQueueReveal: credentialId => "/billqueue/credentials/".concat(credentialId, "/reveal")
};